import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuInfo:{
      list:[],
      activeMenu:null,
      activeSubId:""
    }
  },
  mutations: {
    setMenuInfo(state,val){
      state.menuInfo.list = val;
    },
    setActiveMenu(state,val){
      state.menuInfo.activeMenu = val.activeItem;
      state.menuInfo.activeSubId = val.activeSubId;
    },
  },
  actions: {

  },
  modules: {}
});
